import { i18n } from "@lingui/core";
import { Trans, t } from "@lingui/macro";
import React, { useState } from "react";
import { Redirect } from "react-router";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { DEFAULT_REDIRECT_URI } from "../../constants";
import { getUserInfo, invite, queryByEntity, updateData } from "../../util/APIUtils";
import { error, success } from "../../util/toast";
import AuthLayout from "../layout";

export default function AcceptInvite() {
  const path = useParams();
  const [load, setLoad] = useState(false)

  const handleUpdateEmail = (email, userId, tenantId, token) => {
    const params = {
      entityCode: "employee",
      operatorDTOList: [
        {
          key: "email",
          dataType: "v_string_254",
          value: email,
          filterOperator: "EQ",
          sortOperator: "",
        },
      ],
      pageIndex: 0,
      pageSize: 1,
    };
    queryByEntity("employee", params, token, tenantId).then(response => {
      response.json().then(rs => {
        if (!rs || rs.length === 0) {
          setTimeout(() => {
            window.location.href = DEFAULT_REDIRECT_URI + "/" + "u" + "/" + tenantId;
          }, 3000)
          return
        }
        const employee = rs[0]
        const data = {
          entityCode: "employee",
          attrValueList: [],
          id: employee.id
        };
        const _userId = employee.fields.find(field => field.attrCode === "user_id")?.vlist[0]
        data.attrValueList.push({
          key: 'user_id',
          value: "",
          listValue: _userId ? [_userId] : [userId],
        });
        updateData(employee.id, "employee", data, token,
          tenantId).then(() => {
            setTimeout(() => {
              window.location.href = DEFAULT_REDIRECT_URI + "/" + "u" + "/" + tenantId;
            }, 3000)
          }
          );
      }).catch(() => {
        setTimeout(() => {
          window.location.href = DEFAULT_REDIRECT_URI;
        }, 3000)
      })
    });
  }

  const active = (isActive) => {
    if (isActive) {
      setLoad(true)
      invite(path.id).then(response => {
        response.json().then(rs => {
          setLoad(false)
          if (rs.status === 3) {
            error(i18n._(t`Lời mời đã hết hạn hoặc đã được xác nhận trước đó`))
          } else if (rs.status === 0) {
            error(i18n._(t`Xác nhận thất bại`))
          } else {
            if (rs.status === 1) {
              toast.warn(i18n._(t`Tài khoản của bạn hiện đang thuộc tổ chức này`))
            }
            if (rs.status === 4) {
              toast.warn(i18n._(t`Tài khoản của bạn hiện đang thuộc team này`));
            }
            if (rs.status === 10 || rs.status === 2) {
              success(i18n._(t`Xác nhận thành công`))
            }
            getUserInfo(rs.token).then(response => {
              response.json().then(userInfo => {
                handleUpdateEmail(userInfo.email, rs.userId, rs.tenantId, rs.token)
              })
            }).finally(() => {
              setTimeout(() => {
                window.location.href = DEFAULT_REDIRECT_URI;
              }, 3000)
            }).catch(err => {
              error((err && err.detail) || i18n._(t`Oops, có lỗi xảy ra, vui lòng thử lại sau`))
            })
          }
        })
      }).catch(err => {
        console.log(err)
        setLoad(false)
        error((err && err.detail) || i18n._(t`Oops, có lỗi xảy ra, vui lòng thử lại sau`))
      })
    }
    else {
      success(i18n._(t`Đang chuyển hướng về trang chủ ...`))
      setLoad(false)
      setTimeout(() => {
        window.location.href = DEFAULT_REDIRECT_URI;
      }, 3700)
    }
  }

  if (!path.id) {
    return <Redirect to={'/'} />
  }

  return (
    <AuthLayout>
      <div className={`flex justify-center items-center fixed top-0 left-0 w-screen h-screen bg-gray-500 bg-opacity-50 ${load ? "block" : "hidden"}`}>
        <svg role="status" className="w-40 h-40 mr-2 text-gray-200 animate-spin fill-blue-500"
          viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor" />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill" />
        </svg>
      </div>
      <div>
        <div className="text-luat_HN_primary" style={{ fontWeight: "bold", fontSize: "30px", marginBottom: "50px" }}><Trans>Xác nhận tham gia</Trans>
        </div>
        <div className="flex justify-center text-white">
          <button className="px-5 py-2 mx-2 transition duration-300 bg-red-500 rounded hover:bg-red-400" onClick={() => active(false)}><Trans>Từ chối</Trans></button>
          <button className="px-5 py-2 mx-2 transition duration-300 bg-blue-500 rounded hover:bg-blue-400" type="primary" onClick={() => active(true)}><Trans>Xác nhận</Trans></button>
        </div>
      </div>
    </AuthLayout>
  )
}
